// libs
import { useSelector } from 'react-redux'

// interfaces
import { IProps as ISnackBarProps } from 'src/components/snack_bar/snack_bar'
import { MODAL_TYPE_NONE, PopupMenu } from 'src/interfaces/app-state'
import { IBoundingBox, ILocationShape } from 'src/interfaces/location'
import { IRootState } from 'src/reducers/interface'

export const useGetNavSource = () =>
  useSelector(({ appState }: IRootState) => appState.navSource)

export const useGetAppLocationShape = () =>
  useSelector<IRootState, ILocationShape | undefined>(({ appState }) => appState.locationShape)

export const useGetBoundingBox = () =>
  useSelector<IRootState, IBoundingBox | undefined>(({ appState }) => appState.boundingBox)

export const useGetAppActivePopupMenu = () =>
  useSelector<IRootState, PopupMenu>(({ appState }) => appState.activePopupMenu)

export const useGetSnackBar = () =>
  useSelector<IRootState, ISnackBarProps>(({ appState }) => appState.snackBar)

export const useIsModalOpen = () =>
  useSelector<IRootState, boolean>(({ appState }) => appState.modal !== MODAL_TYPE_NONE)
